export default __webpack_public_path__ + "static/media/N_wdt_c_cap_4.07196ce0.mp3";